/* 
 * PullContentManager.js
 * 
 * @author Olivier van der Pool for Ranj
 */

import { isUndefined } from "/lib/html5-software-library/src/ranj/util/TypeUtil";
import DialogContentComponent from "/lib/html5-software-library/src/ranj/eng/content/DialogContentComponent";

export default class PullContentManager {
    constructor() {
        this._pullDialogsByNpcID = {};
        this._pullContent = [];
        this._pullContentByType = {};
        this._contentPlayersByContent = {};
    }

    addPullContent(content, contentPlayer) {
        this.addPullContentByType(content);

        if (content instanceof DialogContentComponent) {
            if (!isUndefined(content.getNpcID())) {
                this._pullDialogsByNpcID[content.getNpcID()] = content;
            }
        }

        this._pullContent.push(content);
        this._contentPlayersByContent[content.getLabel()] = contentPlayer;
    }

    removePullContent(content) {
        this.removePullContentByType(content);

        if (content instanceof DialogContentComponent && !isUndefined(content.getNpcID())) {
            delete this._pullDialogsByNpcID[content.getNpcID()];
        }

        this._pullContent.remove(content);
        delete this._contentPlayersByContent[content.getLabel()];
    }

    getPullDialogByNpcID(npcID) {
        return this._pullDialogsByNpcID[npcID];
    }

    getPullContentByID(ID) {
        for (let i = 0; i < this._pullContent.length; i++) {
            if (this._pullContent[i]._dialogID === ID) {
                return this._pullContent[i];
            }
        }
        return null;
    }

    getAllPullContent(contentType) {
        if (isUndefined(contentType)) {
            return this._pullContent;
        } else {
            const pullContentByType = this._pullContentByType[contentType];
            if (!isUndefined(pullContentByType)) {
                return pullContentByType;
            }
            return null;
        }
    }

    getContentPlayerForContent(content) {
        return this._contentPlayersByContent[content.getLabel()];
    }

    addPullContentByType(content) {
        let pullContentByType = this._pullContentByType[content.getType()];
        if (isUndefined(pullContentByType)) pullContentByType = [];

        pullContentByType.push(content);
        this._pullContentByType[content.getType()] = pullContentByType;
    }

    removePullContentByType(content) {
        const pullContentByType = this._pullContentByType[content.getType()];
        if (isUndefined(pullContentByType)) return;

        pullContentByType.remove(content);
    }

    get pullContent() {
        return this._pullContent;
    }
}